import  { useEffect, useState } from "react";
import axios from "axios";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
} from "chart.js";
import { CircularProgress, Container, Typography, Box } from "@mui/material";
import config from "../../config.js";

ChartJS.register(
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement
);

const SuccessChart = () => {
  const [chartData, setChartData] = useState({ labels: [], datasets: [] });
  const [error, setError] = useState(null);
  const { API_BASE_URL } = config;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/v1/learningJson`
        );
        

        const rawData = response.data.data.Data;
       

        const teams = [...new Set(rawData.map(item => item["Teams"]))];

        const successfulCallsData = teams.map(team => {
          const teamData = rawData.filter(item => item["Teams"] === team);
          return teamData.reduce((total, item) => total + item["successful calls"], 0);
        });

        const unsuccessfulCallsData = teams.map(team => {
          const teamData = rawData.filter(item => item["Teams"] === team);
          return teamData.reduce((total, item) => total + item["unsuccessful calls"], 0);
        });

        const datasets = [
          {
            label: "Successful Calls",
            data: successfulCallsData,
            backgroundColor: "rgba(75, 192, 192, 0.6)",
            borderColor: "rgba(75, 192, 192, 1)",
            borderWidth: 1,
          },
          {
            label: "Unsuccessful Calls",
            data: unsuccessfulCallsData,
            backgroundColor: "rgba(255, 99, 132, 0.6)",
            borderColor: "rgba(255, 99, 132, 1)",
            borderWidth: 1,
          },
        ];

        setChartData({
          labels: teams,
          datasets: datasets,
        });
      } catch (error) {
        setError(error);
      }
    };

    fetchData();
  }, [API_BASE_URL]);

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!chartData.labels.length) {
    return (
      <Container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Container>
    );
  } else {
    const options = {
      responsive: true,
      scales: {
        x: {
          stacked: true,
        },
        y: {
          stacked: true,
          beginAtZero: true,
        },
      },
      plugins: {
        legend: {
          display: true,
          labels: {
            color: "white", // Color for the legend text
            font: {
              size: 14, // Font size for the legend text
            },
          },
        },
      },
      elements: {
        bar: {
          maxBarThickness: 80, // Increase this value to make the bars thicker
        },
      },
    };

    return (
      <div>
        <Box sx={{ backgroundColor: "#FF4D4D", padding: 2, borderRadius: 1 }}>
          <Typography variant="h5" sx={{ color: "#fff", textAlign: "center" }}>
            Successful vs Unsuccessful Calls by Team
          </Typography>
        </Box>
        <Container>
          <div
            style={{
              padding: "20px",
              width: "100%",
              height: "80%",
            }}
          >
            <Bar data={chartData} options={options} />
          </div>
        </Container>
      </div>
    );
  }
};

export default SuccessChart;
